// variables
import { StyledDrawingIcon } from 'variables';

// libraries
import styled from 'styled-components';

export const StyledPenIcon = styled.svg`
  ${StyledDrawingIcon}
`;
